import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { useLenis } from "lenis/react";
import { Reveal, Overline } from "../Reveal";
import { SERVICES } from "../../data/content";

export default function Services() {
  const lenis = useLenis();
  const goContact = () => {
    const el = document.getElementById("contact");
    if (el && lenis) lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  };
  return (
    <section id="services" data-testid="services-section" className="relative py-16 md:py-24 overflow-hidden bg-gk-panel/30">
      <div className="ambient-emerald" style={{ width: 460, height: 460, top: "0%", left: "-10%", opacity: 0.25 }} />

      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-10">
          <Reveal>
            <Overline>What We Do</Overline>
            <h2 className="font-cinzel text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mt-4 leading-tight">
              Services crafted<br /><span className="text-gold-metallic">to command attention.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-poppins text-sm text-white/55 max-w-sm leading-relaxed">
              A full spectrum of premium creative and technology services — each delivered to an obsessive standard.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const featured = i === 0 || i === 3;
            return (
              <Reveal
                key={s.title}
                delay={(i % 3) * 0.08}
                data-testid={`service-card-${i}`}
                className={featured ? "md:col-span-2" : ""}
              >
                <div
                  data-cursor="hover"
                  className="luxe-card group h-full rounded-2xl p-6 flex flex-col"
                >
                  <div className="flex items-center justify-between mb-5">
                    <div className="w-11 h-11 rounded-xl glass flex items-center justify-center group-hover:border-gk-gold/50 group-hover:scale-105 transition-all duration-500">
                      <Icon />
                    </div>
                    <span className="font-cinzel text-xl text-white/10 group-hover:text-gk-gold/30 transition-colors duration-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-cinzel text-lg text-white mb-2 group-hover:text-gk-champagne transition-colors duration-500">
                    {s.title}
                  </h3>
                  <p className="font-poppins text-sm text-white/55 leading-relaxed">{s.desc}</p>

                  <ul className="mt-4 space-y-1.5">
                    {s.benefits.map((b) => (
                      <li key={b} className="flex items-center gap-2 font-inter text-xs text-white/60">
                        <Check size={13} className="text-gk-gold shrink-0" strokeWidth={3} />
                        {b}
                      </li>
                    ))}
                  </ul>

                  <button
                    data-testid={`service-learn-more-${i}`}
                    onClick={goContact}
                    className="mt-5 inline-flex items-center gap-1.5 font-inter text-xs font-medium text-gk-champagne/80 hover:text-gk-champagne transition-colors group/btn"
                  >
                    Learn More
                    <ArrowRight size={13} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </button>
                  <motion.div className="mt-4 h-px w-0 group-hover:w-full bg-gradient-to-r from-gk-gold to-transparent transition-all duration-700" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
